/**
 * Created by Ivan on 21.08.2025
 */

const WeeklyGoals = function () {
    cleverapps.EventEmitter.call(this);

    this.goals = [];
    this.progress = {};
    this.points = 0;
    this.collected = 0;
    this.loginDay = -1;

    this.chooseConfig();
    this.load();

    this.subscribeToEvents();

    cleverapps.abExperiments.whenGroupsUpdated(this.updateGoals.bind(this));

    cleverapps.whenAllInitialized(() => {
        this.updateGoals();

        connector.platform.on("resume", () => this.updateGoals());
    });
};

WeeklyGoals.prototype = Object.create(cleverapps.EventEmitter.prototype);
WeeklyGoals.prototype.constructor = WeeklyGoals;

WeeklyGoals.prototype.chooseConfig = function () {
    const jsons = bundles.weekly_goals_config.jsons;
    const raw = Object.keys(jsons)
        .filter((key) => key.startsWith("weekly_goals_config_"))
        .map((key) => jsons[key].getJson())
        .flat();

    this.config = {};
    this.types = {};
    raw.forEach((entry) => {
        this.types[entry.name] = entry.id;
        this.config[entry.id] = entry;
    });

    this.eventsToTypes = {};

    Object.keys(this.config).forEach((type) => {
        const event = this.config[type].event;
        if (event) {
            if (!this.eventsToTypes[event]) {
                this.eventsToTypes[event] = [];
            }

            this.eventsToTypes[event].push(parseInt(type));
        }
    });
};

WeeklyGoals.prototype.resolveSpec = function (spec, weekDay) {
    const value = Array.isArray(spec) ? spec[weekDay] : spec;
    if (value && typeof value === "object" && value.random) {
        const random = PseudoRandom.GET().random(value.random[0], value.random[1]);
        return value.step ? Math.round(random / value.step) * value.step : random;
    }
    return value;
};

WeeklyGoals.prototype.resolveTarget = function (type, weekDay) {
    return this.resolveSpec(this.config[type].generate, weekDay);
};

WeeklyGoals.prototype.resolveReward = function (type, weekDay) {
    const reward = this.config[type].reward;
    return this.resolveRewardUnits(Array.isArray(reward) ? reward[weekDay] : reward);
};

WeeklyGoals.prototype.resolveRewardUnits = function (reward) {
    return typeof UnitsLibraryHelper !== "undefined" ? UnitsLibraryHelper.ResolveRewardUnits(reward) : reward;
};

WeeklyGoals.prototype.subscribeToEvents = function () {
    cleverapps.user.on("recheckAvailable", () => this.updateGoals(), this);

    connector.payments.on("purchase", () => this.addProgress(this.types.MAKE_PURCHASE, 1), this);
    cleverapps.eventBus.on("restore_purchase", () => this.addProgress(this.types.MAKE_PURCHASE, 1), this);

    Object.keys(this.eventsToTypes).forEach((event) => {
        cleverapps.eventBus.on(event, (value) => this.processEvent(event, value), this);
    });
};

WeeklyGoals.prototype.updatePointsGoals = function () {
    let totalPoints = 0;
    this.pointsGoals = [];
    this.goals.forEach((goals, index) => {
        goals.forEach((goal) => {
            const reward = this.resolveReward(goal.type, index);
            if (goal.type !== this.types.MAKE_PURCHASE) {
                totalPoints += reward.weekly_goals_points;
            }
        });
    });
    this.pointsGoals = WeeklyGoals.POINTS_GOALS.map((goal) => Math.round(goal * totalPoints / 5) * 5);
    this.pointsGoals.push(totalPoints);

    this.pointsRewards = [];

    for (let i = 0; i < this.pointsGoals.length; i++) {
        this.pointsRewards.push({
            rewards: this.resolveRewardUnits(RewardsConfig.WeeklyGoalPointsRewards[i]),
            event: cleverapps.EVENTS.EARN.WEEKLY_GOALS,
            toMainWorld: !cleverapps.meta.getSelectedLocation().locationConfig.isMain,
            toBubbleStack: true
        });
    }
};

WeeklyGoals.prototype.beforeUpdate = function () {
    clearTimeout(this.timeout);
};

WeeklyGoals.prototype.afterUpdate = function () {
    this.updateGoals();
    this.trigger("updateProgress");
};

WeeklyGoals.prototype.updateInfo = function (serverData) {
    if (!serverData) {
        return;
    }

    this.load(serverData);
    this.save(true);
};

WeeklyGoals.prototype.getInfo = function () {
    return {
        goals: this.goals.map((day) => day.map((task) => task.getInfo())).flat(),
        progress: this.progress,
        week: this.week,
        points: this.points,
        collected: this.collected,
        loginDay: this.loginDay
    };
};

WeeklyGoals.prototype.load = function (serverData) {
    const data = serverData || cleverapps.dataLoader.load(DataLoader.TYPES.WEEKLY_GOALS) || {};

    if (data.loginDay === undefined) {
        data.loginDay = cleverapps.dataLoader.load(DataLoader.TYPES.WEEKLY_GOALS_LOGIN);
    }
    if (data.loginDay === undefined) {
        data.loginDay = -1;
    }

    const flatGoals = (data.goals || []).map((goalInfo, index) => {
        if (!this.config[goalInfo[0]]) {
            return;
        }

        const goal = new WeeklyGoal(goalInfo);
        const day = Math.floor(index / WeeklyGoals.DAILY_AMOUNT);
        goal.setReward(this.resolveReward(goal.type, day));
        return goal;
    }).filter(Boolean);

    this.goals = [];
    for (let i = 0; i < flatGoals.length; i += WeeklyGoals.DAILY_AMOUNT) {
        this.goals.push(flatGoals.slice(i, i + WeeklyGoals.DAILY_AMOUNT));
    }

    this.progress = data.progress || {};
    this.week = data.week || 0;
    this.points = data.points || 0;

    this.updatePointsGoals();

    const collected = this.pointsGoals.reduce((acc, goal, index) => {
        if (this.points >= goal) {
            acc |= (1 << index);
        }
        return acc;
    }, 0);

    if (data.collected === undefined || data.collected > collected && !(collected & (1 << this.pointsGoals.length - 1))) {
        data.collected = collected;
    }

    this.collected = data.collected || 0;
    this.loginDay = data.loginDay;
};

WeeklyGoals.prototype.changeDay = function (day) {
    this.debugCurrentDay = day;
    this.goals.forEach((goals, index) => {
        if (index > day) {
            goals.forEach((goal) => {
                goal.collected = false;
            });
        }
    });
    this.save();

    this.trigger("changeDay");
};

WeeklyGoals.prototype.calcCurrentWeek = function () {
    const date = new Date();
    date.setDate(date.getDate() - this.calcCurrentDay(date));

    const start = new Date("1970-01-01");
    start.setDate(start.getDate() - this.calcCurrentDay(start));

    // we must use DST-free dates to subtract them
    const dateUTC = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());

    // it is necessary to round off values in cases where the start of the current week does not exactly coincide with the start of the week of 1970-01-01 like with DST
    return Math.round((dateUTC - startUTC) / (7 * 24 * 60 * 60 * 1000)) + 1;
};

WeeklyGoals.prototype.calcDayEvent = function (weekNumber, weekDay) {
    const start = new Date(Date.UTC(1970, 0, 1, 0, 0, 0, 0));
    const daysSinceMonday = (start.getUTCDay() + 6) % 7;

    start.setUTCDate(start.getUTCDate() - daysSinceMonday);
    start.setUTCDate(start.getUTCDate() + (weekNumber - 1) * 7 + weekDay);
    start.setUTCHours(12, 0, 0, 0);

    return start.getTime();
};

WeeklyGoals.prototype.calcTimeLeft = function () {
    const now = new Date();
    const dayOfWeek = this.calcCurrentDay();

    const daysBeforeMonday = (7 - dayOfWeek) || 7;

    const endOfWeek = new Date(now);
    endOfWeek.setDate(now.getDate() + daysBeforeMonday);
    endOfWeek.setHours(0, 0, 0, 0);

    return endOfWeek - now;
};

WeeklyGoals.prototype.calcTimeLeftToNextDay = function () {
    const now = new Date();

    const nextDay = new Date(now);
    nextDay.setDate(now.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);

    return nextDay - now;
};

WeeklyGoals.prototype.calcCurrentDay = function (date) {
    if (!date && this.debugCurrentDay) {
        return this.debugCurrentDay;
    }

    return ((date || new Date()).getDay() + 6) % 7;
};

WeeklyGoals.prototype.isNewWeek = function () {
    return this.week !== this.calcCurrentWeek();
};

WeeklyGoals.prototype.calcAllRewards = function (day) {
    let rewards = 0;
    const currentDay = day !== undefined ? day : this.calcCurrentDay();
    this.goals.forEach((goal, day) => {
        rewards += this.calcAvailableRewards(day, currentDay);
    });

    return rewards;
};

WeeklyGoals.prototype.calcFinishedGoals = function (day) {
    let sum = 0;

    const currentDay = day !== undefined ? day : this.calcCurrentDay();
    this.goals.forEach((goals, day) => {
        if (currentDay < day) {
            return;
        }

        goals.forEach((goal) => {
            if (goal.isFinished()) {
                sum++;
            }
        });
    });

    return sum;
};

WeeklyGoals.prototype.calcAvailableRewards = function (day, currentDay) {
    if (currentDay < day) {
        return 0;
    }

    let rewards = 0;

    this.goals[day].forEach((goal) => {
        if (goal.isRewardedAvailable()) {
            rewards++;
        }
    });

    return rewards;
};

WeeklyGoals.prototype.hasCollectedGoals = function (day) {
    return this.goals[day].filter((goal) => goal.collected).length;
};

WeeklyGoals.prototype.updateGoals = function (forceUpdate) {
    if (!this.isAvailable()) {
        return;
    }

    this.logEvents();

    clearTimeout(this.timeout);

    const timeLeft = Math.min(this.calcTimeLeft(), this.calcTimeLeftToNextDay());
    this.timeout = new cleverapps.LongTimeout(this.updateGoals.bind(this), timeLeft);

    if (!this.isNewWeek() && !forceUpdate) {
        this.onLoginEvent();
        return;
    }

    this.logFinishEvents(this.week);

    this.goals = [];
    this.progress = {};
    this.points = 0;
    this.collected = 0;
    this.loginDay = -1;

    this.week = this.calcCurrentWeek();
    this.generateWeeklyGoals();

    cleverapps.dataLoader.remove(DataLoader.TYPES.WEEKLY_GOALS_UNLOCKS);
    this.onLoginEvent(true);

    this.updatePointsGoals();
    this.logPlayer();

    this.save();

    this.trigger("updateGoals");

    if (!cleverapps.focusManager.isFocused() && cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        this.displayWindow();
    } else {
        this.needShowStartWindow = true;
    }
};

WeeklyGoals.prototype.displayWindow = function () {
    cleverapps.focusManager.display({
        focus: "WeeklyGoalsWindow",
        action: function (f) {
            new WeeklyGoalsWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

WeeklyGoals.prototype.isDayClosed = function (day) {
    return this.calcCurrentDay() < day;
};

WeeklyGoals.prototype.wasDayShown = function (day) {
    if (this.hasCollectedGoals(day)) {
        return true;
    }

    const unlocks = cleverapps.dataLoader.load(DataLoader.TYPES.WEEKLY_GOALS_UNLOCKS) || 0;
    return unlocks & (1 << day);
};

WeeklyGoals.prototype.markDayShown = function (day) {
    const unlocks = cleverapps.dataLoader.load(DataLoader.TYPES.WEEKLY_GOALS_UNLOCKS) || 0;
    cleverapps.dataLoader.save(DataLoader.TYPES.WEEKLY_GOALS_UNLOCKS, unlocks | (1 << day));
};

WeeklyGoals.prototype.addPoints = function (amount) {
    let rewardIndex = -1;

    for (let index = 0; index < this.pointsGoals.length; index++) {
        if (this.points < this.pointsGoals[index] && this.points + amount >= this.pointsGoals[index]) {
            rewardIndex = index;
            break;
        }
    }

    this.points += amount;
    this.save();

    new ActionPlayer([
        (f) => {
            this.trigger("updatePoints");
            cleverapps.timeouts.setTimeout(f, 500);
        },
        () => {
            if (rewardIndex === -1) {
                return;
            }

            this.trigger("goalCompleted", rewardIndex);

            if (rewardIndex !== this.pointsGoals.length - 1) {
                this.trigger("givePrize", rewardIndex);
                this.setCollected(rewardIndex);
            }
        }
    ]).play();
};

WeeklyGoals.prototype.isCollected = function (index) {
    return (this.collected & (1 << index)) !== 0;
};

WeeklyGoals.prototype.setCollected = function (index) {
    if (!this.isCollected(index)) {
        this.collected |= (1 << index);
        this.save();
    }
};

WeeklyGoals.prototype.calcWeekSeed = function () {
    return this.week;
};

WeeklyGoals.createRewardWindow = function (rewardConfig) {
    cleverapps.focusManager.display({
        focus: "WeeklyGoalsRewardWindow",
        stack: true,
        action: function (f) {
            new RewardWindow(rewardConfig.rewards, {
                title: Messages.get("WeeklyGoalsRewardWindow.title"),
                name: "weeklygoalsrewardwindow",
                text: Messages.get("WeeklyGoalsRewardWindow.text"),
                toMainWorld: rewardConfig.toMainWorld,
                toBubbleStack: rewardConfig.toBubbleStack,
                event: rewardConfig.event
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

WeeklyGoals.prototype.generateWeeklyGoals = function () {
    PseudoRandom.GET().seed(this.calcWeekSeed());

    this.onceTasksDays = {};
    Object.keys(this.config).forEach((type) => {
        if (this.config[type].once) {
            this.onceTasksDays[type] = PseudoRandom.GET().random(0, 6);
        }
    });

    for (let index = 0; index < 7; index++) {
        this.goals.push(this.generateDailyGoals(index));
    }
};

WeeklyGoals.prototype.getValues = function (goalConfig) {
    const localizedValues = goalConfig.localizedValues;
    if (localizedValues) {
        return localizedValues[cleverapps.settings.language] || localizedValues.default;
    }
    return goalConfig.values;
};

WeeklyGoals.prototype.getLocalizedData = function (type, data) {
    const goalConfig = this.config[type];
    if (!goalConfig.localizedValues) {
        return data;
    }

    const savedValues = Object.values(goalConfig.localizedValues).find((values) => values.includes(data));
    const currentValues = this.getValues(goalConfig);
    if (!savedValues || !currentValues.length) {
        return data;
    }

    const index = savedValues.indexOf(data) % currentValues.length;
    return currentValues[index];
};

WeeklyGoals.prototype.generateDailyGoals = function (weekDay) {
    const allGoals = Object.keys(this.config).map((type) => {
        const goalConfig = this.config[type];

        if (goalConfig.require && !cleverapps.config.features.includes(goalConfig.require)) {
            return undefined;
        }

        if (goalConfig.available && !levels.user.checkAvailable(cleverapps.config.availables[goalConfig.available])) {
            return undefined;
        }

        if (Number(type) === this.types.MAKE_PURCHASE && cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_REGULAR) {
            return undefined;
        }

        if (goalConfig.excludeTypes && goalConfig.excludeTypes.includes(cleverapps.config.type)) {
            return undefined;
        }

        if (goalConfig.days && !goalConfig.days.includes(weekDay)) {
            return undefined;
        }

        const values = this.getValues(goalConfig);
        if (values && !values.length) {
            return undefined;
        }

        return {
            type: Number(type),
            target: this.resolveTarget(Number(type), weekDay),
            data: values && PseudoRandom.GET().choose(values),
            constant: !!goalConfig.constant,
            once: !!goalConfig.once
        };
    }).filter(Boolean);

    const constantGoals = allGoals.filter((goal) => goal.constant);
    const onceGoals = allGoals.filter((goal) => goal.once && this.onceTasksDays[goal.type] === weekDay);
    const variableGoals = allGoals.filter((goal) => !goal.constant && !goal.once);

    const selected = [...constantGoals, ...onceGoals];

    const remaining = Math.max(WeeklyGoals.DAILY_AMOUNT - selected.length, 0);
    if (remaining > 0 && variableGoals.length > 0) {
        PseudoRandom.GET().seed(this.calcWeekSeed() * 10 + weekDay);
        const picked = PseudoRandom.GET().chooseN(
            variableGoals,
            Math.min(remaining, variableGoals.length)
        );
        selected.push(...picked);
    }

    return selected.map((goalInfo) => {
        const goal = new WeeklyGoal([goalInfo.type, goalInfo.target, goalInfo.collected, goalInfo.data]);
        goal.setReward(this.resolveReward(goalInfo.type, weekDay));
        return goal;
    });
};

WeeklyGoals.prototype.onLoginEvent = function (silent) {
    const type = this.types["LOGIN_DAYS"];
    const currentDay = this.calcCurrentDay();

    if (this.loginDay < currentDay) {
        this.addProgress(type, 1, silent);
        this.loginDay = currentDay;
        this.save();
    }

    if (this.calcProgress(type) > currentDay + 1) {
        this.progress[type] = currentDay + 1;
        this.save();
        if (!silent) {
            this.trigger("updateProgress");
        }
    }
};

WeeklyGoals.prototype.processEvent = function (event, value) {
    const types = this.eventsToTypes[event] || [];
    const amount = typeof value === "number" ? value : (value && value.amount) || 1;

    types.forEach((type) => {
        const match = this.config[type].match;
        if (match && !Object.keys(match).every((key) => value && value[key] === match[key])) {
            return;
        }

        const param = this.config[type].param;
        const datas = param ? [].concat(value && value[param]) : [undefined];

        datas.forEach((data) => {
            const goals = this.goals.flat().filter((goal) => goal.type === type && this.getLocalizedData(type, goal.data) === data);
            cleverapps.unique(goals.map((goal) => goal.data)).forEach((goalData) => {
                this.addProgress(type, amount, false, goalData);
            });
        });
    });
};

WeeklyGoals.prototype.progressKey = function (type, data) {
    return data === undefined ? type : `${type}_${data}`;
};

WeeklyGoals.prototype.addProgress = function (type, amount, silent, data) {
    if (!this.isAvailable()) {
        return;
    }

    if (!(amount >= 0)) {
        cleverapps.throwAsync(`weekly goals amount is not a number or negative ${type} ${amount}`);
        return;
    }

    const key = this.progressKey(type, data);
    if (!this.progress[key]) {
        this.progress[key] = 0;
    }

    this.goals.forEach((week, index) => week.forEach((goal) => {
        if (goal.type === type && goal.data === data && goal.checkComplete(amount)) {
            if (!silent) {
                goal.createNotification();
            }

            const event = this.calcDayEvent(this.week, index);
            const eventName = `${cleverapps.EVENTS.WEEKLY_GOALS_COMPLETE_GOAL}_${index}_${this.calcTypeName(goal).slice(0, 30)}`;
            cleverapps.metrics.logEvent(eventName, { event });
        }
    }));

    this.progress[key] += amount;
    this.trigger("updateProgress");

    this.save();
};

WeeklyGoals.prototype.calcTypeName = function (goal) {
    const types = Object.keys(this.types).filter((type) => this.types[type] === goal.type);
    return types.length ? types[0].toLowerCase() : "";
};

WeeklyGoals.prototype.giveGoals = function (day) {
    const dayGoals = this.goals[day || 0];

    const completedGoals = dayGoals.filter((goal) => goal.isFinished() && !goal.collected);
    const collectedGoals = dayGoals.filter((goal) => goal.collected);
    const activeGoals = dayGoals.filter((goal) => !goal.collected && !goal.isFinished());

    return [...completedGoals, ...activeGoals, ...collectedGoals];
};

WeeklyGoals.prototype.calcProgress = function (type, data) {
    return this.progress[this.progressKey(type, data)] || 0;
};

WeeklyGoals.prototype.onCollect = function (type) {
    this.trigger("collectGoal", type);
    this.save();
};

WeeklyGoals.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.WEEKLY_GOALS, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("weeklygoals");
    }
};

WeeklyGoals.prototype.isAvailable = function () {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.weeklyGoalsMatch3) === "B") {
        return false;
    }

    return levels.user.checkAvailable(cleverapps.config.availables.WEEKLY_GOALS);
};

WeeklyGoals.prototype.updateGoalsRewards = function () {
    this.goals.forEach((dailyGoals, dayIndex) => {
        dailyGoals.forEach((goal) => {
            goal.setReward(this.resolveReward(goal.type, dayIndex));
        });
    });
};

WeeklyGoals.prototype.logEvents = function () {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const day = this.calcCurrentDay(yesterday);

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEEKLY_GOALS_AVAILABLE, {
        event: yesterday.getTime()
    });

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEEKLY_GOALS_FINISHED, {
        event: yesterday.getTime(),
        value: this.calcFinishedGoals(day)
    });

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEEKLY_GOALS_UNCLAIMED, {
        event: yesterday.getTime(),
        value: this.calcAllRewards(day)
    });
};

WeeklyGoals.prototype.logPlayer = function () {
    for (let index = 0; index < 7; index++) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.WEEKLY_GOALS_PLAYERS, { event: this.calcDayEvent(this.week, index) });
    }
};

WeeklyGoals.prototype.logFinishEvents = function (week) {
    let finished = 0;
    let total = 0;
    this.goals.forEach((goals) => {
        goals.forEach((goal) => {
            finished += goal.isFinished();
            total++;
        });
    });

    const value = Math.floor(finished / total * 100);
    const event = this.calcDayEvent(week, 6);
    if (value === 100) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.WEEKLY_GOALS_DONE, { event });
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.WEEKLY_GOALS_DONE}_dau`, { event });
    }
};

WeeklyGoals.POINTS_GOALS = [0.1, 0.24, 0.55, 0.78];
WeeklyGoals.DAILY_AMOUNT = 5;

cleverapps.InitByFeature["weekly_goals"] = function () {
    cleverapps.weeklyGoals = new WeeklyGoals();
};

SyncAdapters.weeklygoals = {
    beforeUpdate: () => cleverapps.weeklyGoals.beforeUpdate(),
    afterUpdate: () => cleverapps.weeklyGoals.afterUpdate(),

    getInfo: () => cleverapps.weeklyGoals.getInfo(),

    updateInfo: (serverData) => cleverapps.weeklyGoals.updateInfo(serverData)
};